import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { themes } from "../../core/styles/theme";
import { GlobalStyles } from "../../core/styles";
import { RootState } from "../../core/store/types";
import { darkTheme, lightTheme } from "../../core/styles/theme/colors";

export const wrapWithTheme = (children: JSX.Element): JSX.Element => (
  <ThemeProvider theme={themes}>{children}</ThemeProvider>
);
interface Props {
  children: JSX.Element;
}

const ThemeWrapper: FunctionComponent = ({ children }: Props) => {
  const { theme } = useSelector(
    ({ settingsReducer }: RootState) => settingsReducer
  );

  const themeObject = {
    ...themes,
    color: theme === "light" ? lightTheme : darkTheme,
  };

  return (
    <ThemeProvider theme={themeObject}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
